import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Tooltip,
  Typography
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { enqueueSnackbar } from "notistack";
import { api } from "../../../../services/api";
import useAiStore from "../../../../store/aiStore";
import { errorsMessage } from "../../../../helpers";
import { textToHtml } from "../../../../helpers/textToHtml";

export default function GerarDescricaoIA({ imovelId, onApply }) {
  const { enabled, fetchStatus } = useAiStore(state => state);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [descricao, setDescricao] = useState("");

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  if (!enabled) return null;

  const showError = err => {
    const data = err?.response?.data;

    // Respostas desta feature (403 flag desligada, 404, 503) trazem error + message.
    if (data?.error && data?.message) {
      enqueueSnackbar(data.message, { variant: "error" });
      return;
    }

    if (!err?.response) {
      enqueueSnackbar("Não foi possível gerar a descrição. Tente novamente.", {
        variant: "error"
      });
      return;
    }

    errorsMessage(err, enqueueSnackbar);
  };

  const gerar = async () => {
    setLoading(true);

    try {
      const { data } = await api.post(`/imoveis/${imovelId}/gerar-descricao`);
      setDescricao(data?.data?.descricao || "");
      setOpen(true);
    } catch (err) {
      showError(err);
    } finally {
      setLoading(false);
    }
  };

  const aplicar = () => {
    // A IA às vezes separa parágrafos com quebra simples; cada linha vira um parágrafo, como na prévia.
    onApply(textToHtml(descricao.replace(/\n+/g, "\n\n")));
    setOpen(false);
  };

  const button = (
    <span>
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        startIcon={loading ? <CircularProgress size={16} /> : <AutoAwesomeIcon />}
        disabled={!imovelId || loading}
        onClick={gerar}
      >
        Gerar descrição com IA
      </Button>
    </span>
  );

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end">
      {imovelId ? (
        button
      ) : (
        <Tooltip title="Salve o imóvel para gerar a descrição">{button}</Tooltip>
      )}
      <FormHelperText>A IA usa os dados salvos do imóvel.</FormHelperText>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
        <DialogTitle>Descrição sugerida pela IA</DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ whiteSpace: "pre-line" }}>{descricao}</Typography>
        </DialogContent>
        <DialogActions>
          <Button color="inherit" onClick={() => setOpen(false)}>
            Cancelar
          </Button>
          <Button
            color="secondary"
            onClick={gerar}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} /> : null}
          >
            Gerar novamente
          </Button>
          <Button variant="contained" color="secondary" onClick={aplicar} disabled={loading}>
            Usar texto
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
